import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

if (typeof window !== 'undefined' && typeof window.atob === 'function') {
  const nativeAtob = window.atob.bind(window);
  window.atob = value => {
    try {
      return nativeAtob(value);
    } catch (error) {
      console.warn('Ignored invalid base64 input passed to atob', {
        valuePreview: String(value || '').slice(0, 80),
      });
      return '';
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
